import { render } from "./settings_other.vue?vue&type=template&id=6e3db83a"
import script from "./settings_other.vue?vue&type=script&lang=js"
export * from "./settings_other.vue?vue&type=script&lang=js"
script.render = render

export default script